export class Settings {
    public constructor(settings: any) {
        Object.assign(this, settings);
    }
}
export interface Settings {
    base: string;
    url(url: string): string;
    name: string;
    author: string;
    description: string;
    minDate: string;
    mainMenu: Array<{ icon: [string, string]; title: string; to: string; exact: boolean }>;
    errorPages: {
        default: { icon: [string, string]; title: string; message: string; statusCode: number };
        [code: string]: { icon: [string, string]; title: string; message: string; statusCode: number };
    };
    card: string;
    headerLogo: string;
    footerLogo: string;
    fullTermsPDF: string;
    cardTypeQuestionId: string;
    cardTypeAnswerId: string;
    programId: string;

    patientSurveyId: string;
    eligibilityPatientFederalQuestion: string;
    eligibilityPatientFederalAnswer: string;
    eligibilityPatientPrescribedQuestion: string;
    eligibilityPatientPrescribedAnswer: string;
    eligibilityPatientInsuranceQuestion: string;
    eligibilityPatientInsuranceAnswer: string;
    eligibilityPatientCitizenQuestion: string;
    eligibilityPatientCitizenAnswer: string;
    eligibilityPatientAgeQuestion: string;
    eligibilityPatientAgeAnswer: string;
    patientDoesAgreeQuestion: string;
    patientDoesAgreeAnswer: string;
    patientEnrollmentQuestion: string;
    patientEnrollmentAnswer: string;
    patientCertifyQuestion: string;
    patientCertifyAnswerYes: string;

    pharmacySurveyId: string;
    eligibilityPharmacyAgeQuestion: string;
    eligibilityPharmacyAgeAnswer: string;
    eligibilityPharmacyPrescribedQuestion: string;
    eligibilityPharmacyPrescribedAnswer: string;
    eligibilityPharmacyFederalQuestion: string;
    eligibilityPharmacyFederalAnswer: string;
    eligibilityPharmacyInsuranceQuestion: string;
    eligibilityPharmacyInsuranceAnswer: string;
    eligibilityPharmacyCitizenQuestion: string;
    eligibilityPharmacyCitizenAnswer: string;
    eligibilityPharmacyTermsQuestion: string;
    eligibilityPharmacyTermsAnswer: string;
    pharmacyDoesAgreeQuestion: string;
    pharmacyDoesAgreeAnswer: string;
    pharmacyEnrollmentQuestion: string;
    pharmacyEnrollmentAnswer: string;
    pharmacyCertifyQuestion: string;
    pharmacyCertifyAnswerYes: string;

    triangleUp: string;
    triangleDown: string;
    lockEnabled: string;
    lockPassword: string;
}
